import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@dashboard/components/ui/accordion';
import clsx from 'clsx';

import { Field } from '../Form';
import { renderFields, FormExtensionContext } from '../formUtils';

function Disclosure({
  fields,
  children,
  label,
  inputClassName,
  variant,
  contentClassName,
  defaultOpen = false,
  nested = false,
  // No padding around the trigger, for a form whose dividers already space it.
  flush = false,
  compactRow = false,
  values,
  setFieldValue,
  errors,
  touched,
}) {
  const {
    customFieldPropsAreEqual,
    customLeafFieldNames,
    customContainerChildrenPropsEqual,
    customContainerValuesEqual,
  } = React.useContext(FormExtensionContext);

  if (!fields && !children) return null;

  const itemValue = `disclosure-${label}`;

  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={defaultOpen ? itemValue : undefined}
      className={clsx({ 'border-b-0': nested })}
    >
      <AccordionItem
        value={itemValue}
        className={clsx({ 'border-b-0': nested, 'rounded-lg border last:border-b': compactRow })}
      >
        <AccordionTrigger
          variant={compactRow ? 'inline' : (variant ?? 'compact')}
          className={clsx({
            'text-sm font-medium': !compactRow,
            'py-0': flush,
            'py-2': nested && !flush && !compactRow,
            'py-3': !nested && !flush && !compactRow,
            'flex-1 justify-between rounded-lg px-3 py-1.5 text-[13px] leading-[18px] hover:bg-gray-50 dark:hover:bg-muted [&>svg]:size-3.5 [&>svg]:text-gray-400 dark:[&>svg]:text-muted-foreground':
              compactRow,
          })}
        >
          {label}
        </AccordionTrigger>
        <AccordionContent
          className={clsx(contentClassName, {
            'pt-3': flush,
            'grid gap-3 px-3 pt-1 pb-3 [&>div]:mb-0!': compactRow,
          })}
        >
          {children ??
            renderFields({ fields, values, setFieldValue }).map(field => (
              <Field
                key={field.name}
                field={{
                  ...field,
                  visible: field.visible === undefined ? true : field.visible,
                }}
                values={values}
                setFieldValue={setFieldValue}
                inputClassName={inputClassName}
                errors={errors}
                touched={touched}
                customFieldPropsAreEqual={customFieldPropsAreEqual}
                customLeafFieldNames={customLeafFieldNames}
                customContainerChildrenPropsEqual={customContainerChildrenPropsEqual}
                customContainerValuesEqual={customContainerValuesEqual}
              />
            ))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

export default React.memo(Disclosure);
